import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'has_facility_taken_legally_required_steps_enable_workers_2'

export const dataPointDefinition = {
  retracedId: 'has_facility_taken_legally_required_steps_enable_workers_2',
  name: 'Has the facility taken legally required steps to enable workers with infections or illness (other than HIV/AIDS) to reta',
  description: 'Consult applicable legal requirements before answering this question.',
  meta: {
    slcpMeta: {
      key: 'wt-dis-39',
      number: 'WT-DIS-27',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wt-dis-39', version: '1.7.0', provider: 'slcp'}],
  sortingId: 37320,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
